import {Component, Input} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';

@Component({
    selector: 'app-merchant-user-info-viewer',
    templateUrl: './merchant-user-info-viewer.component.html',
    styleUrls: ['./merchant-user-info-viewer.component.scss']
})
export class MerchantUserInfoViewerComponent extends EditModalSectionBaseComponent {

    constructor( public  editModalService: EditModalService) {
        super(editModalService);
    }
}
